import type { SVGProps } from 'react'
const SvgSyChevronDown = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M5 7.75a.75.75 0 0 0-.531.219.75.75 0 0 0 0 1.062l7 7a.75.75 0 0 0 1.062 0l7-7a.75.75 0 0 0 0-1.062.75.75 0 0 0-1.062 0L12 14.438l-6.469-6.47A.75.75 0 0 0 5 7.75" />
	</svg>
)
export default SvgSyChevronDown
